import {
    GET_MENU_ITEMS,
    DELETE_MENU_ITEM,
    ME_LOADING,
    ADD_MENU_ITEM,
    UPDATE_MENU_ITEM,
    GET_MENU_ITEM_BYID
} from "../actions/MenuItemActions"

const initialState = {
    menuitems: [],
    menuitem: [],
    loading: true,
    success: true,
    addMenuItem: null
};

const MenuReducer = function(state = initialState, action){
    switch (action.type) {
        case ME_LOADING: {
            return {
              ...state,
              loading: true
            }
        }
        case GET_MENU_ITEMS: {
            return {
                ...state,
                menuitems: [...action.data],
                loading: false
            }
        }
        case GET_MENU_ITEM_BYID: {
            return {
                ...state,
                menuitem: [action.data],
                loading: false,
                success: true,
            }
        }
        case ADD_MENU_ITEM: {
            return {
                ...state,
                addMenuItem : action.data,
                success: true,
                loading: false
            }
        }
        case UPDATE_MENU_ITEM: {
            return {
                ...state,
                addMenuItem : action.data,
                success: true,
                loading: false
            }
        }
        case DELETE_MENU_ITEM: {
            return {
                ...state,
                success: true,
                loading: false
            }
        }
        default: {
            return state;
        }
    }
}

export default MenuReducer;
  

